const FILTER_TYPE = require('./advance-filter/filter-type-enum');
const _ = require('lodash');
module.exports = function (filtersService) {
    return {
        restrict: 'E',
        scope: {
            sortSettingGroup: '@'
        },
        link(scope) {
            scope.filtersService = filtersService;
            scope.isFilersOpen = false;
            scope.noOfFilterApplied = 0;

            scope.$watch('filtersService.filters', (filters) => {
                if (filters.length !== 0) {
                    scope.filtersService.initialise(FILTER_TYPE.FILTER_TYPE_MOBILE);
                    scope.noOfFilterApplied = 0;
                    _.each(scope.filtersService.appliedFilter, (obj) => {
                        scope.noOfFilterApplied += obj.Items.length;
                    });
                }
            });
        },
        template: require('./filter-header-mobile-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/filters/filter-header-mobile-directive.js
 **/